export function getCommunitiesDetailPageRoutes(currentModule: string, routePrefix: string) {
  return [
    {
      path: routePrefix,
      name: `${currentModule}/communities-outlet`,
      component: () => import("./components/CommunityDetailWrapper.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [
        {
          path: `:communityId/general`,
          name: `${currentModule}/communities-general`,
          component: () => import("./views/CommunityEditGeneral.vue"),
          meta: {
            isDetailPage: true,
            module: "communities",
          },
        },
      ],
    },
  ]
}

export function getCommunitiesRoutes() {
  return [
    {
      path: "/communities",
      name: "communities",
      component: () => import(/* webpackChunkName: "communities-list" */ "./views/CommunitiesList.vue"),
      children: getCommunitiesDetailPageRoutes("communities", "detail"),
    },
  ]
}
